/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

export const fornitoriAPI = {
  list: async (params = {}) => {
    const { data } = await apiClient.get('/fornitori', { params });
    return data;
  },

  // Attenzione a chi chiama: se la partita IVA esiste gia' il server risponde 409
  // con dentro il fornitore trovato, e non e' un errore da mostrare come tale —
  // e' il caso normale in cui si torna dallo stesso negozio.
  crea: async (payload) => {
    const { data } = await apiClient.post('/fornitori', payload);
    return data;
  },

  modifica: async (id, payload) => {
    const { data } = await apiClient.put(`/fornitori/${id}`, payload);
    return data;
  },

  // Non esiste una cancellazione: le righe di materiale gia' comprate puntano
  // qui, e cancellare renderebbe anonimi acquisti gia' fatti.
  archivia: async (id, attivo) => {
    const { data } = await apiClient.patch(`/fornitori/${id}/attivo`, { attivo });
    return data;
  },
};
